import React from 'react';
import BannerTemplatePropType from 'components/BannerTemplatePropType';
import { Banner } from '@shoflo/polymer/components/Banner/Banner';
import compileTemplate from 'components/BannerLayerSourceForm/compileTemplate';
import PropTypes from 'prop-types';

const colorBank = ['red', 'red', 'red', 'red'];

const textBank = [
  'He who has a why to live can bear almost any how.',
  'Line 2 This is what text looks like in line 2',
  'Line 3 This is what additional text looks like when added to line 3',
  'To live is to suffer, to survive is to find some meaning in the suffering.',
  'That which does not kill us makes us stronger.',
  'Without music, life would be a mistake.',
  'Blessed are the forgetful: for they get the better even of their blunders.',
  'We have art in order not to die of the truth.',
  'There are no facts, only interpretations.'
];

const sampleTypeMap = {
  hexColor: (i, formValues) => {
    let formColorValue = formValues['Accent color'];
    formColorValue = formColorValue ? formColorValue.trim() : '';
    return formColorValue.length ? formColorValue : colorBank[i];
  },
  text: (i, formValues) => {
    let formTextValue = formValues[`Line ${i + 1}`];
    formTextValue = formTextValue ? formTextValue.trim() : '';
    return formTextValue.length ? formTextValue : textBank[i];
  }
};

const getSampleFieldValue = (type, i, formValues) => {
  return sampleTypeMap[type](i, formValues);
};

const compileExampleMarkup = ({ template, fields }, formValues) => {
  // Create the template vars context object
  const templateVars = {};
  fields.forEach(({ key, type }, i) => {
    if (i === 0 && type === 'text') {
      let line1FormText = formValues['Line 1'];
      line1FormText = line1FormText ? line1FormText.trim() : '';
      templateVars[key] = line1FormText.length
        ? line1FormText
        : 'Line 1 Goes Here';
      return;
    }
    templateVars[key] = getSampleFieldValue(type, i, formValues);
  });

  return compileTemplate(template, templateVars);
};

const ExampleBanner = ({ children, formValues = {} }) => {
  return <Banner>{compileExampleMarkup(children, formValues)}</Banner>;
};

ExampleBanner.propTypes = {
  children: BannerTemplatePropType,
  formValues: PropTypes.object
};

export default ExampleBanner;
